<template>
  <div class="home">
    <header class="top poa wm bsb t l z10 transition" :class="{active: headerFixed}">
<!--       <div @click="toFloor()" class="dib vam logo cp transition"></div> -->
      <span>广州格林软件技术有限公司</span>
      <div class="fr btn">
        <a class="cp" @click="toFloor(floorTops['fa'])">解决方案</a>
        <a class="cp" @click="toFloor(floorTops['hz'])">合作案例</a>
       <!--  <a class="cp" @click="toFloor(floorTops['lx'])">联系我们</a> -->
        <!--<a class="cp" target="_blank" href="/20200828121618.jpg">关于我们</a>-->
      </div>
    </header>

    <div class="banner por tac" ref="banner">
      <div class="title">AI教育-智能设备整体解决方案</div>
      <div class="subtitle">幼儿及K12全学龄段的海量资源，多模态AI方案，多场景支持故事机、学习平板、教育机器人等智能设备</div>
      <div class="poa box b vwm tac">
        <div class="item bgw dib bsb" v-for="(item, i) in bannerBox" :key="i">
          <img :src="item.src" class="ico">
          <div class="i-title">{{item.title}}</div>
          <div class="i-subtitle">{{item.subtitle}}</div>
          <div class="line dib vam"></div>
        </div>
      </div>
    </div>

    <div class="ziyuan tal bsb transition1" :class="{df: !ziyuanShow}" ref="zy">
      <div class="item clearfix" v-for="(item, i) in ziyuan" :key="i">
        <img :src="item.src" class="img vam hm transition1">
        <div class="text col-flex jce hm bsb">
          <div class="title">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
        </div>
      </div>
    </div>

    <div class="duihua tar bsb transition1" :class="{df: !duihuaShow}" ref="dh">
      <div class="title transition">丰富对话场景<br>人机闲聊过程更加形象生动</div>
      <div class="subtitle">闲聊+问答+多轮对话，支持智能人机对话的流畅体验，集合教育、<br>趣味娱乐、生活类知识丰富问答，实现对话人性化效果。</div>
      <div class="icons">
        <div class="item por dib vam" v-for="(item, i) in duihua" :key="i">
          <img :src="item.src" class="ico wm">
          <div class="text abs-c">{{item.text}}</div>
        </div>
      </div>
    </div>

    <div class="mokuai tac" ref="mk" :class="{df: !mokuaiShow}">
      <div class="title">精美教育模块聚集</div>
      <div class="subtitle">用户可以自主定义语义平台、运营系统、资源系统、客户系统，形成品牌差异化优势。</div>
      <div class="list flex jcb fww">
        <div class="item dib vam cp transition"
             :style="{transitionDelay: i * .2 + 's'}"
             v-for="(item, i) in mokuai" :key="i">
          <img :src="item.src" class="ico transition">
          <div class="text transition">{{item.text}}</div>
        </div>
      </div>
    </div>

    <div class="xueqian bsb tac transition1" ref="xq" :class="{df: !xueqianShow}">
      <div class="title">学前教育</div>
      <div class="list flex jcb fww">
        <div :class="{active: activeXueQian === i}"
             class="item dib vam cp"
             @mouseenter="xueQianChange(i)"
             v-for="(item, i) in xueqian" :key="i">
          <img :src="activeXueQian === i ? item.src : item.ico" class="ico">
          <div class="text">{{item.title}}</div>
        </div>
      </div>
      <div class="content tal bgw bsb">
        <div class="por hm">
          <div v-for="(item, i) in xueqian" :key="i"
               :class="activeXueQian === i ? 'op1 z1' : 'op0'"
               class="inner transition poa hm wm t l">
            <img :src="item.img" class="fl img">
            <div class="c-title">{{item.title}}</div>
            <div class="inner wsp">{{item.text}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="zhongxiao tac bsb" ref="zx">
      <div class="title">中小学教育</div>
      <div class="list flex jcb">
        <div class="item bsb" :style="{backgroundImage: `url(${item.bg})`}" v-for="(item, i) in zhongxiao" :key="i">
          <img :src="item.ico" class="ico">
          <div class="name">{{item.name}}</div>
          <div class="line dib vam"></div>
          <div class="text">{{item.text}}</div>
        </div>
      </div>
    </div>

    <div class="tongyong bsb por z1" ref="ty">
      <div v-for="(item, i) in tongyong" :key="i"
           :style="{backgroundImage: `url(${item.bg})`}"
           class="bg poa wm hm l t z-1 transition"
           :class="activeTongYong === i ? 'op1' : 'op0'">
      </div>
      <div class="title tac">通用功能</div>
      <div class="list bsb">
        <div class="item transition bsb cp"
             @mouseenter="tongYongChange(i)"
             :class="{'active bgw': activeTongYong === i}" v-for="(item, i) in tongyong"
             :key="i">
          <div class="content transition bsb hm">
            <div class="name">
              <img :src="activeTongYong === i ? item.src : item.ico" class="ico"><span>{{item.name}}</span>
            </div>
            <div class="text">{{item.text}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="fangan bsb tac" ref="fa">
      <div class="title">教育机器人整体解决方案</div>
      <div class="list flex jcb">
        <div class="item" v-for="(item, i) in fangan" :key="i">
          <div class="img transition cp" :style="{backgroundImage: `url(${item.img})`}"></div>
          <div class="name">{{item.name}}</div>
          <div class="line"></div>
          <div class="content tal wsp">{{item.content}}</div>
        </div>
      </div>
    </div>

    <div class="hezuo bsb tac bg" ref="hz">
      <div class="title">合作案例</div>
    </div>

    <div class="shangbiao bsb tac" ref="sb">
      <div class="title">合作伙伴</div>
      <div class="subtitle">排名不分先后</div>
      <div class="list tal">
        <div class="item dib vam transition cp"
             :style="{backgroundImage: `url(${item.img})`}"
             v-for="(item, i) in shangbiao" :key="i">
        </div>
      </div>
    </div>

<!--     <div class="lianxi tac bsb" ref="lx">
      <div class="title">联系我们</div>

      <div class="types flex jcb">
        <div class="type bsb">
          <div class="name">商务合作</div>
          <div class="content">
			 <p>
              宋总<br>
              手机：189 9832 0238<br>
              邮箱：3405507386@qq.com
            </p>

            <p>
              梁经理<br>
              手机：176 2082 7383（微信同号）<br>
              邮箱：2776877636@qq.com
            </p>

            <p>
              小燕<br>
              手机：182 0067 6731<br>
              邮箱：695823414@qq.com
            </p>
			 <p>
              蓝经理<br>
              手机：135 3040 0622<br>
              邮箱：13530400622@163.com
            </p>

          </div>

        </div>

        <div class="type bsb">
          <div class="name">客服咨询</div>
          <div class="content" align="center">
            <p align="center">
              电话咨询：18925187565
            </p>
            <p align="center">
              微信咨询：18925187565
            </p>
            <p style="opacity: 0">---</p>
            <p align="center"><img style="margin-top: 10px;" src="../images/kf.jpg" width="140"><br>客服二维码</p>
          </div>

        </div>

        <div class="type bsb">
          <div class="name">产品体验</div>
          <div class="content">
            <div class="content-top">
              <p>产品链接：</p>
              <p>
                <a target="_blank" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.wyt.iexuetang.hd.xxtb">同步小学课堂</a>
                <a target="_blank" href="http://video.english163.com/iexue_pic/y1h2Eq1545727568.apk">中小学辅导班</a>
              </p>
              <p>
                <a target="_blank"
                   href="https://a.app.qq.com/o/simple.jsp?pkgname=com.wyt.iexuetang.hd.iexuetang">格灵课堂</a>
                <a target="_blank" href="http://www.yunstudy.cn">格灵教育云平台</a>
              </p>
            </div>
            <p align="center"><img src="../images/glkt.jpg" width="150"><br>格灵课堂公众号</p>

          </div>

        </div>

      </div>


    </div> -->
<!--     <div class="lianxi tac bsb" ref="lx">
      <div class="title">友情链接</div>
      <div class="content">

        <p><a href="http://sj.zol.com.cn/" target="_blank">ZOL手机应用</a></p>

      </div>


    </div> -->

    <div class="fixed-right">
   <!--    <p align="center" class="p"><img class="img fir" src="../images/kf.jpg"><br>客服二维码</p> -->
     <!--  <p align="center" class="p"><img class="img sec" src="../images/glkt.jpg"><br>格灵课堂公众号</p> -->
    </div>

    <footer class="bottom tac z10 por">
      <div class="abs-mc wm">
        <!--<div>© 2003-2016 广州格灵信息科技有限公司 版权所有 推荐使用IE6.0以上版本的浏览器&nbsp;-->
        <!--<a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备15051375号-2</a>-->
        <!--</div>-->
        <div class="flex jcc tal aic">
          <div class="b-left">
            <p class="flex">
              <span>公司名称: </span>
              <span class="flex-1">广州格林软件技术有限公司</span>
            </p>
            <p class="flex">
              <span>公司地址: </span>
              <span class="flex-1">广东省广州市黄埔区科学大道182号广州科学城创意大厦B1栋附楼1103室</span>
            </p>
            <p class="flex">
              <span>版权: </span>
              <span class="flex-1">C2024版权所有</span>
            </p>
            <p class="flex">
              <span>备案号: </span>
              <a class="flex-1" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024256356号</a>
            </p>
            <!-- <div style="opacity: .6">
              <img src="../images/police_ico.png" class="vam">
              &nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011602000361"
                       target="_blank">粤公网安备
              44011602000361号</a>
            </div> -->
          </div>
          <!--<div class="b-center">-->
          <!--</div>-->
      <!--     <a :href="yyzz" target="_blank" class="b-right">
            <img class="vam wm" :src="yyzz">
          </a> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "home",
    data() {
      return {
        yyzz: require('../images/20200828121618.jpg'),
        headerFixed: false,
        bannerBox: [
          {title: 'AI前沿技能全接入', subtitle: '图灵 讯飞 思必驰', src: require('../images/banner_icon_01.png')},
          {title: '海量幼儿教育内容', subtitle: '格林教育', src: require('../images/banner_icon_02.png')},
          {title: '多形态教育输出方式', subtitle: '不限于SDK、API、H5等', src: require('../images/banner_icon_03.png')},
        ],
        ziyuanShow: false,
        ziyuan: [
          {
            title: '英语口语评测',
            content: '基于同步教材英语和课外专题英语的多版本、多场景口语评测通过智能语音技术，自动对发音水平进行评价、发音错误、缺陷定位等多维度评测，家长端可实时查看学情报告。',
            src: require('../images/ziyuan_01.png')
          },
          {
            title: 'AR课本识读',
            content: '可快速识别各大出版社，各学段教材内容，配套语音交互调用，视频，习题帮助孩子同步学习。翻哪页，读哪页，讲哪页，学哪页！',
            src: require('../images/ziyuan_02.png')
          },
          {
            title: '资源即时推送',
            content: '海量同步精讲、微知识点视频，家长端在线点播收藏、即时推送至机器人端播放。',
            src: require('../images/ziyuan_03.png')
          },
        ],
        duihuaShow: false,
        duihua: [
          {src: require('../images/duihua_01.png'), text: '维基百科'},
          {src: require('../images/duihua_02.png'), text: '儿童聊天'},
          {src: require('../images/duihua_03.png'), text: '十万个为什么'},
          {src: require('../images/duihua_04.png'), text: '知识库'},
        ],
        mokuaiShow: false,
        mokuai: [
          {src: require('../images/mokuai_01.png'), text: '同步课堂'},
          {src: require('../images/mokuai_02.png'), text: '中英文互译'},
          {src: require('../images/mokuai_03.png'), text: '口语评测'},
          {src: require('../images/mokuai_04.png'), text: '多元智能'},
          {src: require('../images/mokuai_05.png'), text: 'AR'},
          {src: require('../images/mokuai_06.png'), text: '互动学习'},
          {src: require('../images/mokuai_07.png'), text: '资源推送'},
          {src: require('../images/mokuai_08.png'), text: '幼教馆'},
        ],
        xueqianShow: false,
        xueqian: [
          {
            title: '蒙特梭利',
            ico: require('../images/xueqian_icon_01.png'),
            src: require('../images/xueqian_icon_active_01.png'),
            img: require('../images/mengte_03.png'),
            text: '蒙特梭利系列以Montessori早教理念为基础，根据0~6岁幼儿的大脑发育特点设计了数学、科学、感官三大类共61个游戏；通过系统的蒙特梭利课程来启发婴幼儿的学习和发展，让孩子感受科学的同时增强其动手能力，在互助中体验蒙特梭利教育精粹。'
          },
          {
            title: '多元智能',
            ico: require('../images/xueqian_icon_02.png'),
            src: require('../images/xueqian_icon_active_02.png'),
            img: require('../images/duoyuan_03.png'),
            text: '八大模块；超过100个游戏；八大领域，旨在锻炼：口头语言及文字的能力、数字和推理的智能、空间结构及它们之间关系认知、运用整个身体来表达想法和感觉能力、感知音律节奏和音色能力、理解别人及与人交往能力、认知自我的能力。'
          },
          {
            title: '逻辑思维',
            ico: require('../images/xueqian_icon_03.png'),
            src: require('../images/xueqian_icon_active_03.png'),
            img: require('../images/luoji_03.png'),
            text: '结合权威幼教理念——“蒙特梭利”与“多元智能”理论，搭配有趣精彩的多媒体课件。\n独有的五大专业板块，为幼儿量身定制的“全脑开发”。\n通过系统性、多方位对幼儿逻辑思维进行强化训练，形成闭合式的强化。'
          },
          {
            title: '乖宝养成',
            ico: require('../images/xueqian_icon_04.png'),
            src: require('../images/xueqian_icon_active_04.png'),
            img: require('../images/guaibao_03.png'),
            text: '该板块主要训练孩子的情商、习惯、礼仪、安全，使其在日常生活中，能够更好的结交朋友、待人接物，养成更好的生活习惯，爱护自己的身体，远离危险，或在危险中保护自己。'
          },
          {
            title: '寓教于乐',
            ico: require('../images/xueqian_icon_05.png'),
            src: require('../images/xueqian_icon_active_05.png'),
            img: require('../images/yujiao_03.png'),
            text: '看、听、唱、玩大集合。\n上千个动画视频，通过不同的手段让孩子从中学习到知识。'
          },
        ],
        activeXueQian: 0,
        zhongxiao: [
          {
            name: '同步课堂',
            ico: require('../images/zhongxiao_icon_01.png'),
            bg: require('../images/zhongxiao_bg_01.png'),
            text: '与课本同步的海量讲解视频、知识点归纳、配套习题。从小学到高中，所有科目主流版本全覆盖。'
          },
          {
            name: '互动学习',
            ico: require('../images/zhongxiao_icon_02.png'),
            bg: require('../images/zhongxiao_bg_02.png'),
            text: '丰富的语数英学习小游戏，寓教于乐，让孩子轻松掌握知识。还有生动的可互动英语绘本，让孩子直观地理解英语句子。'
          },
          {
            name: '知识宝典',
            ico: require('../images/zhongxiao_icon_03.png'),
            bg: require('../images/zhongxiao_bg_03.png'),
            text: '九大科目精心制作的知识速查电子书，配合8本英汉古文辞典，为孩子学习提速。'
          },
        ],
        tongyong: [
          {
            name: 'AR课本识读',
            bg: require('../images/tongyong_ar_01.png'),
            src: require('../images/tongyong_icon_active_01.png'),
            ico: require('../images/tongyong_icon_01.png'),
            text: '与课本同步的海量讲解视频、知识点归纳、配套习题。从小学到高中，所有科目主流版本全覆盖。'
          },
          {
            name: '即时通讯',
            bg: require('../images/tongyong_js_01.png'),
            src: require('../images/tongyong_icon_active_02.png'),
            ico: require('../images/tongyong_icon_02.png'),
            text: '支持即时语音聊天、视频聊天，截屏留住亲子欢笑一刻。实时视频互动，弥补陪伴缺席。'
          },
          {
            name: '中英互译',
            bg: require('../images/tongyong_zy_01.png'),
            src: require('../images/tongyong_icon_active_03.png'),
            ico: require('../images/tongyong_icon_03.png'),
            text: '支持中文翻译为英语，标准发音，模拟真实对话场景，让学英语变得更有趣。'
          },
        ],
        activeTongYong: 0,
        fangan: [
          {
            name: '有屏教育机器人整体解决方案',
            img: require('../images/jiqiren_01.png'),
            content: '*对接科大讯飞、思必驰、图灵等语音语义入口，为机器人开发商或整机厂商提供便捷的一站式产品方案。\n*包涵海量教育资源，其中幼教资源是由知名教育专家联袂出品的国学、故事、儿歌、启蒙、英语、识字六大模块。K12资源包含名师同步课堂和知识点微课两大模块。涵盖全国所有教材版本与知识点微课。专题课堂涵盖奥数精讲、妙解教材、作文指导、必考点、英语口语、英语语法、英语单词、综合集萃等8个模块。\n*特色功能模块包括AI智能交互，百科问答，儿童闲聊等趣味技能。包含即时通讯聊天、视频监控、远程操作机器人等功能，守护儿童在家安全，拉近亲子距离。实现同步教材英语口语评测，家长端实时获取学习详情报告。提供AR趣味学习场景，囊括课本识读、魔法涂涂乐，认识卡片等AR应用。更具有中英互译、语音汉字宝、关爱推送等等特色功能。\n*支持功能场景定制，打造以多功能为基础，教育、智能、陪伴为核心的带屏机器人。'
          },
          {
            name: '英语学习机',
            img: require('../images/jiqiren_02.png'),
            content: '*根据便捷式设备特色，以教育学习资源为基础，结合AI语音语义技能，打造深受家长欢迎的智能英语学习机。\n*支持语音唤醒词定制，灵活定制角色名称，同时包含百科问答、儿童趣聊、儿歌故事、音乐点播等AI技能。\n*实时定位设备，让父母第一时间把控孩子走向，通过电话拨号、语音聊天、视频聊天等方式联系孩子，查看孩子历史移动轨迹，安全守护孩子每一天。\n*包含口语评测、中英互译特色学习应用，满足孩子随时随地学习英语的场景需求，家长端实时获取学习详情报告。\n*具备健康运动、闹钟秒表、电量监控等便捷式设备通用技能。'
          },
          {
            name: '无屏教育机器人整体解决方案',
            img: require('../images/jiqiren_03.png'),
            content: '*以海量教育资源为基础，结合AI技能，打造深受孩子喜爱，家长认可的学习机器人。\n*去掉屏幕干扰，让孩子学习更加专注，获得全新的自主学习体验\n*按键、语音搜索、手机推送，3大方式，点播各大名牌节目，故事、英语、国学、儿歌样样有。\n*包含中英互译特色学习应用，满足孩子随时随地学习英语的场景需求，家长端实时获取学习详情报告。\n'
          }
        ],
        hezuo: [],
        shangbiao: [
          {name: '', img: require('../images/shangbiao_01.png')},
          {name: '', img: require('../images/shangbiao_02.png')},
          {name: '', img: require('../images/shangbiao_03.png')},
          {name: '', img: require('../images/shangbiao_04.png')},
          {name: '', img: require('../images/shangbiao_05.png')},
          {name: '', img: require('../images/shangbiao_06.png')},
          {name: '', img: require('../images/shangbiao_07.png')},
          {name: '', img: require('../images/shangbiao_08.png')},
          {name: '', img: require('../images/shangbiao_09.png')},
          {name: '', img: require('../images/shangbiao_10.png')},
          {name: '', img: require('../images/shangbiao_11.png')},
          {name: '', img: require('../images/shangbiao_12.png')},
          {name: '', img: require('../images/shangbiao_13.png')},
          {name: '', img: require('../images/shangbiao_14.png')},
          {name: '', img: require('../images/shangbiao_15.png')},
          {name: '', img: require('../images/shangbiao_16.png')},
          {name: '', img: require('../images/shangbiao_17.png')},
          {name: '', img: require('../images/shangbiao_18.png')},
          {name: '', img: require('../images/shangbiao_19.png')},
          {name: '', img: require('../images/shangbiao_20.png')},
          {name: '', img: require('../images/shangbiao_21.png')},
          {name: '', img: require('../images/shangbiao_22.png')},
          {name: '', img: require('../images/shangbiao_23.png')},
          {name: '', img: require('../images/shangbiao_24.png')},
          {name: '', img: require('../images/shangbiao_25.png')},
        ],
        lianxi: [
          {name: '商务合作', email: 'waiyutong2018@163.com', ico: require('../images/lianxi_icon_01.png')},
          {name: '客服咨询', email: 'waiyutong2018@163.com', ico: require('../images/lianxi_icon_02.png')},
          {name: '产品体验', email: 'waiyutong2018@163.com', ico: require('../images/lianxi_icon_02.png')}
        ],

        floorTops: {},
        scrollTop: 0,
      }
    },
    watch: {
      scrollTop(val) {
        this.headerFixed = val >= this.floorTops.zy * 1.8;
        if (!this.ziyuanShow) {
          this.ziyuanShow = this.domShow('zy');
        }
        if (!this.duihuaShow) {
          this.duihuaShow = this.domShow('dh');
        }
        if (!this.mokuaiShow) {
          this.mokuaiShow = this.domShow('mk');
        }
        if (!this.xueqianShow) {
          this.xueqianShow = this.domShow('xq');
        }
      },
    },
    methods: {
      domShow(ref, sTop = this.scrollTop, vh = this.floorTops.zy) {
        return ref && this.floorTops[ref] - sTop <= vh * .6;
      },
      xueQianChange(index) {
        this.activeXueQian = index;
      },
      tongYongChange(index) {
        this.activeTongYong = index;
      },
      getFloorTops() {
        // console.log(this.$refs);
        Object.keys(this.$refs).map(e => {
          this.floorTops[e] = this.$refs[e].offsetTop;
        })
      },
      toFloor(top = 0) {
        if (!this.headerFixed && !top) {
          return location.reload();
        }
        let t = document.body.scrollTop || document.documentElement.scrollTop;
        // let h = (top - t) / 20;
        let h = top > t ? 100 : -100;
        let move = () => {
          if (h >= 0 && t + h < top || h < 0 && t + h > top) {
            t += h;
            setTimeout(() => {
              move();
            });
          } else {
            t = top;
          }
          document.body.scrollTop = t;
          document.documentElement.scrollTop = t;
        };
        move();
      },
      setScrollTop(e) {
        this.scrollTop = e.target.scrollingElement.scrollTop;
      }
    },
    created() {
    },
    mounted() {
      window.onscroll = this.setScrollTop;
      this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.getFloorTops();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home.vue